const homePk = {
	hero: {
		title: 'گرامین بازار میں خوش آمدید',
		subtitle: 'اپنی ضرورت کی اشیاء تلاش کریں',
	},
	search: {
		placeholderDefault: 'مصنوعات تلاش کریں...',
		typewriterPlaceholders: [
			'تازہ سبزیاں',
			'پھل',
			'روزمرہ کریانہ',
			'ادویات',
			'الیکٹرانکس',
		],
	},
	partners: {
		heading: 'ہمارے پارٹنرز',
		subheading: 'قابلِ اعتماد اداروں کے ساتھ تعاون',
	},
};

export default homePk;


